import React from "react";
import { cleanDate } from "../../../../util/app";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";

const ObservationDetail = ({ item }) => {
    return (
        <>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Administration</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong className="text-primary">Date of Observation</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{cleanDate(item.date)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong className="text-primary">Date Next Due</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{cleanDate(item.nextDate)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong className="text-primary">Staff</strong>
                                </td>
                                <td>
                                    <StaffProfileCard item={item.author} />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Rationale</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.rationale}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Consent</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.consent}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Observation</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>Height (cm)*</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <span className="text-primary">{item.observation.height}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>Weight (kg)*</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <span className="text-primary">{item.observation.weight}</span>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>BMI</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <span className="text-primary">{item.observation.bmi}</span>
                                </td>
                            </tr>
                            {item.observation.more.map((_item, idx) => (
                                <tr key={idx}>
                                    <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                        <strong>{_item.key}</strong>
                                    </td>
                                    <td style={{ width: "40%" }}>
                                        <span className="text-primary">{_item.value}</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Glasgow Coma Scale</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Best Eye Response</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <span className="text-primary">{item.glasgow.eye}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Best Verbal Response</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <span className="text-primary">{item.glasgow.verbal}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Best Motor Response</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <span className="text-primary">{item.glasgow.motor}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Rapid Tranquilisation</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Please select when obs taken</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.tranquilization.taken}</span>
                                </td>
                            </tr>

                            {item.tranquilization.selected.map((opt, idx) => (
                                <tr key={idx}>
                                    <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                        <strong>{opt}</strong>
                                    </td>
                                    <td>
                                        <span class="material-icons text-primary">check_box</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>QRisk3</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>QRisk3 Score</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.qRisk.score}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Has a Medication Reconciliation been undertaken?</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.qRisk.taken}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Comments on Medication Reconciliation</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.qRisk.comment}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Smoking</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Smoking Status</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.smoke.status}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Number of Cigarette a day</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.smoke.noCigaret}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Has Patient been offered Smoking Cessation?</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.smoke.offeredCessation}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>If yes, what was the outcome?</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.smoke.outcome}</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>If No, reason</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{item.smoke.reasonForNo}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default ObservationDetail;
